import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import DetailsView from '../DetailsView';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember, fetchArtistUsers } from '../../../actions/admin/models/artists';
import ArtistInputs from '../../../components/admin/forms/artists/ArtistInputs';
import ArtistShow from '../../../components/admin/forms/artists/ArtistShow';
import Tabs from '../AdminTabs';
import AdminTable from '../AdminTable';
import { get, map, filter, capitalize } from 'lodash';
import { UserContext } from '../../../Application';
import { PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import { goToContact } from '../../../actions/admin/models/contacts';
import { fetchEventsAsDependency } from '../../../actions/admin/models/events';

class Details extends Component {
    _transformRows = {
        functionName: (_, data) => {
            return map(
                filter(get(data, 'roles'), x => x.function),
                x => capitalize(x.function.replace(/_/g, ' '))
            ).join(', ');
        }
    };
    render() {
        return (
            <Tabs
                disable={!this.props.match.params.artistId}
                labels={['Details']}
                content={[
                    <React.Fragment>
                        <DetailsView
                            fetchDependencies={this.props.fetchEventsAsDependency}
                            model={MODELS.ARTIST}
                            withShowMode={!!this.props.match.params.artistId}
                            fetchModel={this.props.fetchMember}
                            modelId={this.props.match.params.artistId}
                            editView={ArtistInputs}
                            showView={ArtistShow}
                            updateAction={this.props.update}
                            createAction={this.props.create}
                        />
                        {this.props.match.params.artistId ? (
                            <div className="ckp-summary-table">
                                <h1 className="ckp-summary-table-title ckp-ts-h1 u-index-top ">Members</h1>
                                <UserContext.Consumer>
                                    {user => (
                                        <AdminTable
                                            openItem={this.props.goToContact}
                                            blockRowInteraction={() => !hasPermissions(user, PERMISSIONS.CONTACTS_VIEW)}
                                            transformFunctions={this._transformRows}
                                            fetchDataFunction={this.props.fetchArtistUsers}
                                            disableButtonAction={true}
                                            model={MODELS.ARTIST_PARTNER_CONTACT}
                                            forceNoSelect={true}
                                            subContextId={this.props.match.params.artistId}
                                            pagination={true}
                                        />
                                    )}
                                </UserContext.Consumer>
                            </div>
                        ) : null}
                    </React.Fragment>
                ]}
            />
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { create, update, fetchMember, fetchEventsAsDependency, fetchArtistUsers, goToContact },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.ARTISTS, BREADCRUMB.ARTISTS_FORM]));
